import { createContext, useContext } from 'react';

export const UserContext = createContext<any>({});

export function useUserContext() {
  const context = useContext(UserContext);

  return context;
}
